import { status } from 'skin/event/status';
import pickCell from './cell';

const row = (obj, form, story, data, d, action) => {
	switch (obj.table) {
		case 'pickCell':
			return pickCell(obj, form, story, data, d, action);
		default:
	}
	return status.action;
};

export default row;
